// removed by extract-text-webpack-plugin
module.exports = {"animatedEllipsis":"_1kHl3Vw-uIv0QSFurqz0Yl","animatedDot":"RD8Um6dX_d7YL1AttDm_n"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Loading.css
 ** module id = 590
 ** module chunks = 0
 **/